import * as React from 'react';

import { Wrapper, StyledSwitch } from './styles';

interface SwitchProps {
	name: string;
	isActive: boolean;
	onChange: () => void;
	label?: React.ReactNode;
	activeColor?: string;
}

const Switch = ({
	name,
	isActive,
	onChange,
	label,
	activeColor,
}: SwitchProps) => (
	<Wrapper>
		{label}
		<StyledSwitch
			isActive={isActive}
			activeColor={activeColor}
		>
			<input
				type="checkbox"
				name={name}
				checked={isActive}
				onChange={onChange}
			/>
		</StyledSwitch>
	</Wrapper>
);

export default Switch;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Form/Switch/index.tsx